enum RoutesEnum {
  HOME = '/',
  CONNECT = 'connect',

  FOUNDER_DINNERS = 'founder-dinners',
  BUSINESS_OWNER_DINNERS = 'business-owner-dinners',
  SERVICE_PROVIDER_DINNERS = 'service-provider-dinners',
  FUNDRAISING_DINNERS = 'fundraising-dinners',
  BIZ_DEV_DINNERS = 'biz-dev-dinners',
  SPEAKER_SERIES = 'speaker-series',
  ONLINE_COMMUNITY = 'online-community',
  ADVICE_DINNERS = 'advice-diners',

  BUILD = 'build',
  LEARN = 'learn',
  FUND = 'fund',
  GROW = 'grow',
  PRICING = 'pricing',
  PARTNER = 'partner',
  ABOUT = 'about',
  TERMS_OF_USE = 'terms',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIE_POLICY = 'cookie-policy',

  SIGN_IN = 'sign-in',
  SIGN_UP = 'sign-up',
  CREATE_PASSWORD = 'create-password',
  FORGOT_PASSWORD = 'forgot-password',
  RESET_PASSWORD = 'reset-password',
  PASSWORD_CHANGED = 'password-changed',
  CONFIRM_EMAIL = 'confirm-email',
  NAME_AND_ROLES = 'name-and-roles',
  HOW_ASTRONOMIC_WORKS = 'how-astronomic-works',

  ONBOARDING = 'onboarding',
  ONBOARDING_STEP_1 = 'tell-us-about-yourself',
  ONBOARDING_STEP_2 = 'how-astronomic-works',
  ONBOARDING_STEP_3 = 'rocket-fuel-credits',
  ONBOARDING_STEP_4 = 'your-profile',

  COMPLETE_PROFILE = 'complete-profile',
  COMPLETE_PROFILE_LEGACY = 'complete-profile-legacy',

  MANIFESTO = 'manifesto',

  ACCOUNT = 'account',
  BILLING = 'billing',
  ROCKET_FUEL = 'rocket-fuel',
  ACCOUNT_BOOST = 'boost',
  ROLE = 'role',
  QUIZ = 'quiz',
  ADD = 'add',
  EDIT = 'edit',
  PROFILE = 'profile',

  UI_UX_DESIGN = 'ui-ux-design',
  PITCH_DECK_DESIGN = 'pitch-deck-design',
  BRAND_IDENTITY_DESIGN = 'brand-identity-design',
  WEB_DEVELOPMENT = 'wep-development',
  MOBILE_DEVELOPMENT = 'mobile-development',
  API_INTEGRATIONS = 'api-integrations',
  TECH_STACK = 'tech-stack',
  DATA_ARCHITECTURE = 'data-architecture',
  DEV_SEC_OPS = 'dev-sec-ops',

  SERVICE_DETAIL = 'service-detail',
  CASE_STUDY = 'case-study',

  SCHEDULE_MEETING = 'schedule-meeting',

  WELCOME = 'welcome',

  APPS = 'apps',
  CONSTELLATION_DINNERS = 'constellation-dinners',
  CODE_OF_CONDUCT = 'code-of-conduct',
  DINING_PREFERENCES = 'dining-preferences',
  UPCOMING_EVENT = 'upcoming-event',
  PAST_EVENTS = 'past-events',
  PREFERENCES = 'preferences',
  GENERAL = 'general',

  NOT_FOUND = 'not-found',
}

export default RoutesEnum;
